let companySwitchInProgress = false;

export function getCompanySwitchInProgress(): boolean {
  return companySwitchInProgress;
}

export function setCompanySwitchInProgress(v: boolean): void {
  companySwitchInProgress = v;
}
